import { InjectionToken } from '@angular/core';

export const IS_EXTERNAL_WINDOW = new InjectionToken<boolean>('IS_EXTERNAL_WINDOW');
